import React, { useState, useEffect } from "react";
import IdNameModel from "../../../models/common/IdNameModel";
import { Controller, useForm } from "react-hook-form";
import toasterUtils from "../../../utils/toaster-utils";
import InterviewerProfileModel from "../../../models/interviewer/request/InterviewerProfileModel";
import MasterDataService from '../../../services/master-data-service';
import { OBJECT_NAME_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import { TextField, Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, Autocomplete } from "@mui/material";

interface InterviewerProfileProps {
    objInterviewerProfile: InterviewerProfileModel;
    primarySkillList: IdNameModel[];
    secondarySkillList: IdNameModel[];
    actionType: string;
    onProfileSaved: (formData: InterviewerProfileModel) => void;
    onCloseProfile: () => void;
}

const InterviewerProfilePopupComponent = (props: InterviewerProfileProps) => {
    console.log("InterviewerProfilePopupComponent props: ", props);
    const [secondarySkills, setSecondarySkills] = useState<number[]>([0, 0, 0, 0, 0]);
    const [secondarySkillList, setSecondarySkillList] = useState<IdNameModel[]>(props.secondarySkillList);
    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        reset,
        control,
        formState: { errors, isValid },
    } = useForm<InterviewerProfileModel>({
        mode: "onChange",
        defaultValues: props.objInterviewerProfile
    });

    const getSecondarySkills = (primarySkillId: number) => {
        if (primarySkillId !== 0) {
            MasterDataService.loadSecondarySkills(primarySkillId).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setSecondarySkillList(res.items);
            }).catch((error) => {
                toasterUtils.showError("Erorr fetching Primary skills");
            });
        } else {
            toasterUtils.showError("Please Select Primary Skill");
        }
    };

    const onSubmit = (formData: InterviewerProfileModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        formData.interviewerId = props.objInterviewerProfile.interviewerId;
        formData.interviewerProfileId = props.objInterviewerProfile.interviewerProfileId;
        formData.interviewerSkills.forEach(function (item, index) {
            item.secondarySkillId = Number(item.secondarySkillId);
            item.secondarySkillNumber = index + 1;
        });
        var skillsDuplicateArr = formData.interviewerSkills.map(function (item) { return item.secondarySkillId });
        var isDuplicate = skillsDuplicateArr.some(function (item, idx) {
            return skillsDuplicateArr.indexOf(item) != idx
        });
        if (formData.interviewerSkills.filter(x => x.secondarySkillId === 0).length > 0 || isDuplicate) {
            toasterUtils.showError("Secondary skills as mandatory and should be unique.");
        } else {
            props.onProfileSaved(formData);
        }
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.profileName}>
                        <TextField type="text" label="Profile Name" size="small" {...register("profileName", OBJECT_NAME_RULE)} error={!!errors.profileName}
                            helperText={errors.profileName?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <Controller name="primarySkillId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.primarySkillList.find(x => x.id === field.value) || null}
                                onChange={(_, newValue) => { field.onChange(newValue ? newValue.id : 0); getSecondarySkills(newValue ? newValue.id : 0); }} options={props.primarySkillList} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Primary Skill" size="small" required margin="normal" fullWidth error={!!errors.primarySkillId} helperText={errors.primarySkillId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                {secondarySkills?.map((skill, index) => (
                    <div className="col-md-6" key={index}>
                        <Controller name={`interviewerSkills.${index}.secondarySkillId`} control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                            render={({ field }) => (
                                <Autocomplete {...field} value={secondarySkillList.find(x => x.id === field.value) || null}
                                    onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={secondarySkillList} getOptionLabel={(option) => option.name || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label={`Secondary Skill ${index + 1}`} size="small" required margin="normal" fullWidth error={!!errors.interviewerSkills?.[index]?.secondarySkillId} helperText={errors.interviewerSkills?.[index]?.secondarySkillId?.message} />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            )}
                        />
                    </div>
                ))}
            </div>
            <div className="row">
                <div className="col-md-9"></div>
                <div className="col-md-3 text-end">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseProfile}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default InterviewerProfilePopupComponent;